import { Components } from '@mui/material';

export function getMuiFormHelperText(): Components['MuiFormHelperText'] {
  return {
    styleOverrides: {
      root: {
        fontSize: 13,
        marginLeft: 0,
      },
    },
  };
}
